import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "~/utils/queryClient";
import { Outlet } from "react-router";

export default function V1() {
  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
    </QueryClientProvider>
  );
}
